import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import styles from "./styles.module.scss";

const Slider = ({ 
  items = [], 
  renderSlide,
  slidesPerView = 4,
  spaceBetween = 20,
  speed = 10000,
  autoplay = true,
  mobileGrid = false,
}) => {
  return (
    <>
      {/* Mobile Grid */}
      {mobileGrid && (
        <div className={styles.mobileGrid}>
          {items.map((item, index) => (
            <div key={index} className={styles.gridItem}>
              {renderSlide(item, index)}
            </div>
          ))}
        </div>
      )}

      {/* Desktop Slider */}
      <Swiper
        modules={[Autoplay, FreeMode]}
        slidesPerView={slidesPerView}
        spaceBetween={spaceBetween}
        loop={true}
        freeMode={true}
        autoplay={autoplay ? {
          delay: 1,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        } : false}
        speed={speed}
        grabCursor={true}
        breakpoints={{
          320: { slidesPerView: 2, spaceBetween: 10 },
          768: { slidesPerView: 2, spaceBetween: 15 },
          1024: { slidesPerView: 3, spaceBetween: 20 },
          1280: { slidesPerView: slidesPerView, spaceBetween: spaceBetween },
        }}
        style={{ height: "auto" }}
        className={mobileGrid ? styles.desktopSlider : styles.slider}
      >
        {items.map((item, index) => (
          <SwiperSlide key={index}>
            {renderSlide(item, index)}
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default Slider;
